<template>
<svg viewBox="0 0 130 130" xmlns="http://www.w3.org/2000/svg" :class="[`${prefix}-icon`, `${prefix}-icon-psm-nginx`]" width="1em" height="1em" v-bind="$attrs"><path d="M42.5,0 L0,24.5 L0,73.5 L42.5,98 L85,73.5 L85,24.5 L42.5,0 Z M67.0310245,67.7425 C67.0310245,70.62125 64.3898509,73.01 60.7797018,73.01 C58.1998557,73.01 55.2561328,71.96875 53.4163059,69.7025 L28.8852814,40.5434166 L28.8852814,67.7384166 C28.8852814,70.6825 26.5548341,73.0059166 23.6765272,73.0059166 L23.3658009,73.0059166 C20.4179894,73.0059166 18.0916306,70.5559166 18.0916306,67.7384166 L18.0916306,30.2575 C18.0916306,27.37875 20.6673882,24.99 24.2243867,24.99 C26.8655604,24.99 29.8665224,26.03125 31.7063492,28.2975 L56.1147186,57.4565834 L56.1147186,30.2575 C56.1147186,27.3134166 58.5678211,24.99 61.3888889,24.99 L61.6955267,24.99 C64.6392496,24.99 66.969697,27.44 66.969697,30.2575 L66.969697,67.7425 L67.0310245,67.7425 Z" transform="translate(22 16)" :fill="useCurrentColor ? 'currentColor' : '#019639'" fill-rule="nonzero"/></svg>
</template>
<script>

export default {
  name: 'IconPsmNginx',
  props: {
    prefix: {
        type: String,
        default: 'psm',
    },
    useCurrentColor: {
        type: Boolean,
        default: false,
    },
  },
};
</script>
